import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing development configuration and user profile

/**
 * Class representing a summarized cash flow table view.
 * @extends JetView
 */
export default class tableFlujoCajaResumidoView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const id_partner = this.getParam('partner', true); // Get the partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var leftSplit = 1; // Variable to determine left split visibility

        // Extend the summTreeColumn filter to calculate sums for tree columns
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format the result based on the column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from existing summColumn filter
        );

        // Adjust leftSplit based on screen width
        webix.ready(function () {
            if (screen.width < 500) {
                leftSplit = 0; // No left split for small screens
            } else {
                leftSplit = 1; // Enable left split for larger screens
            }
        });

        // Configuration for partner selected as '0'
        if (devConfig.getPartnerSelected() == '0') {
            return {
                view: 'treetable', // Define the view as a tree table
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the table
                bready: function () {
                    this.openAll(); // Open all rows by default
                },
                scrollY: true, // Enable vertical scrolling
                height: screen.width < 820 ? 450 : 0, // Set height based on screen width
                columns: [
                    // Define columns for the tree table
                    {
                        id: 'Fecha', // Column ID
                        header: _('Fecha'), // Column header with localization
                        width: 300, // Column width
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Group template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer text
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets', // Tickets count column
                        header: _('Cantidad Tickets'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivo', // Cash entry value column
                        header: _('V.Entradas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'VoidedPlacedBets', // Voided bets column
                        header: _('Apuestas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto', // Net cash entry value column
                        header: _('V.Entradas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasBonoTC', // Bonus/T.C. entry value column
                        header: _('V.Entradas Bono/T.C'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 140, // Column width
                    },
                    {
                        id: 'ValorEntradasTraslados', // Transfer entry value column
                        header: _('V.Entradas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 145, // Column width
                    },
                    {
                        id: 'ValorEntradasRecargas', // Recharge entry value column
                        header: _('V.Entradas Recargas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Tax', // Tax column
                        header: _('Impuestos'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivo', // Cash exit value column
                        header: _('V.Salidas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto', // Net cash exit value column
                        header: _('V.Salidas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasTraslados', // Transfer exit value column
                        header: _('V.Salidas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorSalidasNotasRetiro', // Withdrawal note exit value column
                        header: _('V.Salidas N.Retiro'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Saldo', // Balance column
                        header: _('Saldo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 100, // Column width
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        // Show loading overlay before data load
                        this.showOverlay(
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        webix.extend(this, webix.OverlayBox); // Extend with overlay box
                        this.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // Show no data message
                                '</div>',
                        );
                    }
                },
                autowidth: false, // Disable auto width
                math: true, // Enable math operations
                loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                leftSplit: leftSplit, // Set left split configuration
                pager: 'pagerA', // Set pager ID
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido?Partner=' + id_partner + '&', // Set data URL
            };
        } else if (devConfig.getPartnerSelected() == '1') {
            // Configuration for partner selected as '1'
            return {
                view: 'treetable', // Define the view as a tree table
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the table
                bready: function () {
                    this.openAll(); // Open all rows by default
                },
                scrollY: true, // Enable vertical scrolling
                height: screen.width < 820 ? 450 : 0, // Set height based on screen width
                columns: [
                    // Define columns for the tree table
                    {
                        id: 'Fecha', // Column ID
                        header: _('Fecha'), // Column header with localization
                        width: 300, // Column width
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Group template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer text
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets', // Tickets count column
                        header: _('Cantidad Tickets'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivo', // Cash entry value column
                        header: _('V.Entradas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto', // Net cash entry value column
                        header: _('V.Entradas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasBonoTC', // Bonus/T.C. entry value column
                        header: _('V.Entradas Bono/T.C'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 140, // Column width
                    },
                    {
                        id: 'ValorEntradasTraslados', // Transfer entry value column
                        header: _('V.Entradas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 145, // Column width
                    },
                    {
                        id: 'ValorEntradasRecargas', // Recharge entry value column
                        header: _('V.Entradas Recargas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Tax', // Tax column
                        header: _('Impuestos'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivo', // Cash exit value column
                        header: _('V.Salidas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto', // Net cash exit value column
                        header: _('V.Salidas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasTraslados', // Transfer exit value column
                        header: _('V.Salidas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorSalidasNotasRetiro', // Withdrawal note exit value column
                        header: _('V.Salidas N.Retiro'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Saldo', // Balance column
                        header: _('Saldo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 100, // Column width
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        // Show loading overlay before data load
                        this.showOverlay(
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        webix.extend(this, webix.OverlayBox); // Extend with overlay box
                        this.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // Show no data message
                                '</div>',
                        );
                    }
                },
                autowidth: false, // Disable auto width
                math: true, // Enable math operations
                loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                leftSplit: leftSplit, // Set left split configuration
                pager: 'pagerA', // Set pager ID
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido?Partner=' + id_partner + '&', // Set data URL
            };
        } else if (devConfig.getPartnerSelected() == '2') {
            // Configuration for partner selected as '2'
            return {
                view: 'treetable', // Define the view as a tree table
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the table
                bready: function () {
                    this.openAll(); // Open all rows by default
                },
                scrollY: true, // Enable vertical scrolling
                height: screen.width < 820 ? 450 : 0, // Set height based on screen width
                columns: [
                    // Define columns for the tree table
                    {
                        id: 'Fecha', // Column ID
                        header: _('Fecha'), // Column header with localization
                        width: 300, // Column width
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Group template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer text
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets', // Tickets count column
                        header: _('Cantidad Tickets'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivo', // Cash entry value column
                        header: _('V.Entradas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto', // Net cash entry value column
                        header: _('V.Entradas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasBonoTC', // Bonus/T.C. entry value column
                        header: _('V.Entradas Bono/T.C'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 140, // Column width
                    },
                    {
                        id: 'ValorEntradasTraslados', // Transfer entry value column
                        header: _('V.Entradas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 145, // Column width
                    },
                    {
                        id: 'ValorEntradasRecargas', // Recharge entry value column
                        header: _('V.Entradas Recargas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Tax', // Tax column
                        header: _('Impuestos'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivo', // Cash exit value column
                        header: _('V.Salidas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto', // Net cash exit value column
                        header: _('V.Salidas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasTraslados', // Transfer exit value column
                        header: _('V.Salidas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorSalidasNotasRetiro', // Withdrawal note exit value column
                        header: _('V.Salidas N.Retiro'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Saldo', // Balance column
                        header: _('Saldo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 100, // Column width
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        // Show loading overlay before data load
                        this.showOverlay(
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        webix.extend(this, webix.OverlayBox); // Extend with overlay box
                        this.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // Show no data message
                                '</div>',
                        );
                    }
                },
                autowidth: false, // Disable auto width
                math: true, // Enable math operations
                loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                leftSplit: leftSplit, // Set left split configuration
                pager: 'pagerA', // Set pager ID
                url: devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido?Partner=' + id_partner + '&', // Set data URL
            };
        } else {
            // Default configuration for other partners
            return {
                view: 'treetable', // Define the view as a tree table
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                id: 'CashResume', // Unique ID for the table
                bready: function () {
                    this.openAll(); // Open all rows by default
                },
                scrollY: true, // Enable vertical scrolling
                height: screen.width < 820 ? 450 : 0, // Set height based on screen width
                columns: [
                    // Define columns for the tree table
                    {
                        id: 'Fecha', // Column ID
                        header: _('Fecha'), // Column header with localization
                        width: 300, // Column width
                        template: function (obj, common) {
                            if (obj.$group)
                                return (
                                    common.treetable(obj, common) + obj.value // Group template
                                );
                            return obj.Fecha; // Return date value
                        },
                        footer: _('Total:'), // Footer text
                    },
                    { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                    { id: 'Moneda', header: _('Moneda'), width: 70 }, // Currency column
                    {
                        id: 'CantidadTickets', // Tickets count column
                        header: _('Cantidad Tickets'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.intFormat, // Formatting function
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivo', // Cash entry value column
                        header: _('V.Entradas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'VoidedPlacedBets', // Voided bets column
                        header: _('Apuestas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasEfectivoNeto', // Net cash entry value column
                        header: _('V.Entradas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorEntradasBonoTC', // Bonus/T.C. entry value column
                        header: _('V.Entradas Bono/T.C'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 140, // Column width
                    },
                    {
                        id: 'ValorEntradasTraslados', // Transfer entry value column
                        header: _('V.Entradas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 145, // Column width
                    },
                    {
                        id: 'ValorEntradasRecargas', // Recharge entry value column
                        header: _('V.Entradas Recargas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Tax', // Tax column
                        header: _('Impuestos'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivo', // Cash exit value column
                        header: _('V.Salidas Efectivo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'VoidedPaidBets', // Voided paid bets column
                        header: _('Apuestas Pagadas Anuladas'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasEfectivoNeto', // Net cash exit value column
                        header: _('V.Salidas Efectivo Neto'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 125, // Column width
                    },
                    {
                        id: 'ValorSalidasTraslados', // Transfer exit value column
                        header: _('V.Salidas Traslados'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 135, // Column width
                    },
                    {
                        id: 'ValorSalidasNotasRetiro', // Withdrawal note exit value column
                        header: _('V.Salidas N.Retiro'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 142, // Column width
                    },
                    {
                        id: 'Saldo', // Balance column
                        header: _('Saldo'), // Header text
                        footer: { content: 'summTreeColumn' }, // Footer content
                        format: webix.i18n.priceFormat, // Formatting function
                        exportType: 'number', // Export type
                        width: 100, // Column width
                    },
                ],
                on: {
                    onBeforeLoad: function () {
                        // Show loading overlay before data load
                        this.showOverlay(
                            "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                        );
                    },
                    onAfterLoad: function () {
                        this.hideOverlay(); // Hide loading overlay after data load
                    },
                },
                ready: function () {
                    if (!this.count()) {
                        webix.extend(this, webix.OverlayBox); // Extend with overlay box
                        this.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                _('No hay datos') + // Show no data message
                                '</div>',
                        );
                    }
                },
                autowidth: false, // Disable auto width
                math: true, // Enable math operations
                loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                leftSplit: leftSplit, // Set left split configuration
                pager: 'pagerA', // Set pager ID
            };
        }
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Get the partner ID from parameters
        var url = devConfig.geturlApi() + 'es/Financial/GetFlujoCajaResumido?Partner=' + id_partner + '&'; // Set the API URL

        // Event handler for after data load
        grid.attachEvent('onAfterLoad', function () {
            // Group data by 'Punto'
            $$('CashResume').data.group({
                by: 'Punto',
                map: {
                    Partner: ['Partner'],
                    Punto: ['Punto'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by 'Agent'
            $$('CashResume').data.group({
                by: 'Agent',
                map: {
                    Partner: ['Partner'],
                    Agent: ['Agent'],
                    CountryId: ['CountryId'],
                    CountryIcon: ['CountryIcon'],
                    Moneda: ['Moneda'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by country icon
            $$('CashResume').data.group({
                by: function (obj) {
                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.CountryId; // Return formatted country icon and ID
                },
                map: {
                    Moneda: ['Moneda'],
                    Partner: ['Partner'],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                    ValorEntradasEfectivo: ['ValorEntradasEfectivo', 'sum'],
                    ValorEntradasEfectivoNeto: ['ValorEntradasEfectivoNeto', 'sum'],
                    ValorEntradasBonoTC: ['ValorEntradasBonoTC', 'sum'],
                    ValorEntradasTraslados: ['ValorEntradasTraslados', 'sum'],
                    ValorEntradasRecargas: ['ValorEntradasRecargas', 'sum'],
                    Tax: ['Tax', 'sum'],
                    ValorSalidasEfectivo: ['ValorSalidasEfectivo', 'sum'],
                    ValorSalidasEfectivoNeto: ['ValorSalidasEfectivoNeto', 'sum'],
                    ValorSalidasTraslados: ['ValorSalidasTraslados', 'sum'],
                    ValorSalidasNotasRetiro: ['ValorSalidasNotasRetiro', 'sum'],
                    VoidedPaidBets: ['VoidedPaidBets', 'sum'],
                    VoidedPlacedBets: ['VoidedPlacedBets', 'sum'],
                    Saldo: ['Saldo', 'sum'],
                },
            });
            // Group data by partner icon
            $$('CashResume').data.group({
                by: function (obj) {
                    return (
                        "<i style='background-image:url(" +
                        profile.Partners.filter((item) => {
                            return item.id == obj.Partner;
                        })[0].image +
                        ") !important;' class='partner " +
                        obj.Partner +
                        "'></i>"
                    ); // Return formatted partner icon
                },
                map: {
                    Partner: ['Partner'],
                    Moneda: [],
                    CantidadTickets: ['CantidadTickets', 'sum'],
                },
            });
        });

        // Event handler for filtering data
        this.on(this.app, 'flujoCajaResumido:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
